import { isNil } from '@pct-ts/typeguard';
import { environment } from '@szebit-app/environment';

export function removeSplashScreen(document: Document): void {
  setTimeout(
    () => {
      const splashElement = document.getElementById('splash');
      if (!isNil(splashElement)) {
        splashElement.classList.add('init_done');
        setTimeout(() => {
          splashElement.remove();
        }, 2000);
      }
    },
    environment.isAngularDevMode ? 0 : 1000,
  );
}
